import Vue from 'vue'
import store from '../../vue/store'
import Toasted from 'vue-toasted'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import InitialData from '../../vue/data-components/InitialData.vue'
import LiveProductData from '../../vue/data-components/LiveProductData.vue'
import AdvCart from './AdvCart'
import AdvProductCard from './AdvProductCard.vue'
import AdvButtonViewBuy from './AdvButtonViewBuy.vue'
import AdvCartProductList from './AdvCartProductList.vue'
import AdvCartGiftList from './AdvCartGiftList.vue'
import AdvProductGallery from './AdvProductGallery.vue'
import AdvMinicartGiftChoiceModal from './AdvMinicartGiftChoiceModal';
import AdvProductGalleryWithVideo from './AdvProductGalleryWithVideo.vue'
import CheckoutPage from './CheckoutPage'
import config from '../../vue/config/configPlugin'
import clientConfigurationBundle from './config'
import locale from '../../vue/locales/localePlugin'
import clientLocaleBundle from './locales'
import jqueryVueBridgePlugin from '../../vue/plugins/jqueryVueBridgePlugin'
import CookieModal from './cookies/components/CookieModal.vue'
import CookieSettingsButton from './cookies/components/CookieSettingsButton.vue'
import AdvButtonViewBuyCombo from '../../main/vue/AdvButtonViewBuyCombo.vue'
const GiftCardPage = () => import(/* webpackChunkName: "gift-card-page" */ '../../main/vue/giftCards/GiftCardPage.vue')

//const CheckoutPage = () => import(/* webpackChunkName: "checkout-page" */ '../../main/vue/CheckoutPage.vue')
//const googleMapPartners = () => import(/* webpackChunkName: "google-map-partners" */ '../../main/vue/googleMaps/components/googleMapPartners.vue')
//const AllListingFilters = () => import(/* webpackChunkName: "all-listing-filters" */ '../../main/vue/AllListingFilters.vue')
//const AdvListingUsedFilters = () => import(/* webpackChunkName: "adv-listing-used-filters" */ '../../main/vue/AdvListingUsedFilters.vue')
//const AdvButtonViewBuyCombo = () => import(/* webpackChunkName: "adv-button-view-buy-combo" */ '../../main/vue/AdvButtonViewBuyCombo.vue')
//const AdvProductGallery = () => import(/* webpackChunkName: "adv-product-gallery" */ '../../main/vue/AdvProductGallery.vue')

Vue.use(Toasted, { iconPack: 'fontawesome' })
Vue.use(VueTinyLazyloadImg)
Vue.use(config, { clientConfigurationBundle: clientConfigurationBundle })
Vue.use(locale, { clientLocaleBundle: clientLocaleBundle })
Vue.use(jqueryVueBridgePlugin)

window.Vue = new Vue({
  el: '#app',
  store,
  config,
  locale,
  jqueryVueBridgePlugin,
  components: {
    InitialData,
    LiveProductData,
    AdvProductCard,
    AdvButtonViewBuy,
    AdvCartProductList,
    AdvCartGiftList,
    AdvProductGallery,
    AdvCart,
    AdvProductGalleryWithVideo,
    CheckoutPage,
    AdvMinicartGiftChoiceModal,
    CookieModal,
    CookieSettingsButton,
    AdvButtonViewBuyCombo,
    GiftCardPage
  },
  data: function () {
    return {
      previewOrderCost: 0
    }
  },
  computed: {
    countCartProducts () {
      return store.getters.cartProductsCount
    },
    countCartProductPieces () {
      return store.getters.cartProductPiecesCount
    },
    cartHasProduct () {
      return !store.getters.cartEmpty
    },
    cartTotal () {
      return store.getters.cartProductsTotal.toFixed(2)
    },
    productCardModal () {
      return store.getters.productCardModal
    },
    cartProductWeightTotal () {
      return store.getters.cartProductWeightTotal
    },
    cartDefaultCouponCode () {
      return store.getters.getDefaultCouponCode
    },
    cartDefaultCouponDiscount () {
      return parseFloat(store.getters.getDefaultCouponDiscount).toFixed(2)
    },
    cartDefaultCouponName () {
      return store.getters.getDefaultCouponName
    },
    selectedCurrency () {
      return store.getters.getSelectedCurrency
    }
  },
  methods: {
    closeProductCardModal () {
      store.dispatch('closeProductCardModal')
    },
    getCartTotalWithPreviewOrderCost () {
      return (this.cartTotal * 1) + this.previewOrderCost
    },
    isCartTotalAbovePaidAtStoreMinCartTotalLimit () {
      return this.cartTotal > _.get(window, ['advAppData', 'previewOrder', 'minCartLimitForPaidAtStorePayway'])
    },
    checkConnectionStatus () {
      store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  },
  mounted () {
    this.$on('cartTotalUpdated', function (newCostValue) {
      this.previewOrderCost = newCostValue * 1
    })
  }
})
